import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.css']
})
export class PartnerComponent implements OnInit {
  partners: any[] = [];
  loading = false;
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 0;
  searchTerm = '';
  baseUrl = environment.imgUrl;
  arr: any[] = [];
  page = 1;
  route = '/partner';
  // which list to show: '' (partners), 'request' (sent), 'received'
  listType: string = '';
  // Add Partner modal state
  partnerName: string;
  candidateCommunities: any[] = [];
  filteredCommunities: any[] = [];
  selectedCommunityIds: string[] = [];
  selectedCommunities: any[] = [];
  // selector pagination
  selSkip = 0;
  selLimit = 20;
  selLoading = false;
  selAllLoaded = false;
  selQuery = '';
  loginUser=''

  constructor(
    private authService: AuthservicesService,
    private ngxLoader: NgxUiLoaderService,
    private modalService: NgbModal,
    private routeSvc: ActivatedRoute,
    private router: Router
  ) { 
    let userCacheRecords = JSON.parse(localStorage.getItem('ministry_currentUser'));
    this.loginUser=userCacheRecords?._id 

  }

  ngOnInit(): void {
    // Initialize skeleton array
    this.arr = Array(6).fill(0);
    // watch query param listType
    this.routeSvc.queryParamMap.subscribe((q) => {
      const t = (q.get('listType') || '').trim();
      this.listType = (t === 'request' || t === 'received') ? t : '';
      this.currentPage = 1;
      this.loadPartners();
    });
  }

  loadPartners() {
    this.loading = true;
    this.ngxLoader.startLoader('loader-01');
    this.authService.getPartnerList(this.listType).subscribe(
      (res: any) => {
        // accept either {data} or {items}
        this.partners = res?.data || res?.items || [];
        const total = typeof res?.total === 'number' ? res.total : this.partners.length;
        this.totalPages = Math.ceil(total / this.itemsPerPage) || 0;
        this.loading = false;
        this.ngxLoader.stopLoader('loader-01');
      },
      (error) => {
        console.error('Error loading partners:', error);
        this.loading = false;
        this.ngxLoader.stopLoader('loader-01');
      }
    );
  }

  search(event: any) {
    this.searchTerm = event.target.value;
    this.currentPage = 1;
    this.loadPartners();
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.loadPartners();
  }

  setPagination(page: number) {
    this.currentPage = page;
    this.loadPartners();
    return page;
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.goToPage(this.currentPage + 1);
    }
  }

  getErrorImage(event: any) {
    this.authService.geterrorImage(event);
  }

  renderImage(photo: string) {
    if (photo) {
      const [baseUrl, imgUrl] = photo.split('uploads');
      return `${this.baseUrl}uploads${imgUrl}`;
    }
    return environment.errorImage;
  }

  // helpers to normalize row shapes across tabs
  itemOf(row: any) {
    if (this.listType === 'received') {
      return row?.requestedBy || row;
    }
    if (this.listType === 'request') {
      return row?.communityId || row;
    }
    return row;
  }

  getName(row: any) {
    const it = this.itemOf(row);
    return it?.name || '—';
  }

  getEmail(row: any) {
    const it = this.itemOf(row);
    return it?.email || row?.user?.email || '—';
  }

  getPhoto(row: any) {
    const it = this.itemOf(row);
    return it?.photo || '';
  }

  // ===== Add Partner modal logic (choose partner) =====
  openAddPartner(templateRef: any) {
    this.partnerName = null;
    this.selectedCommunities = [];
    this.selectedCommunityIds = [];
    this.getCommunitiesForSelector();
    this.modalService.open(templateRef, { scrollable: true });
  }

  getCommunitiesForSelector(reset: boolean = false) {
    if (this.selLoading || this.selAllLoaded) return;
    if (reset) {
      this.selSkip = 0;
      this.selAllLoaded = false;
      this.candidateCommunities = [];
      this.filteredCommunities = [];
    }
    this.selLoading = true;
    this.authService.getCommunity(this.selSkip, this.selLimit, this.selQuery || this.searchTerm, 'selectAssociation')
      .subscribe((res: any) => {
     const oldPartnerIds = Array.isArray(this.partners) ? this.partners.map(partner => partner._id) : [];
     const items = Array.isArray(res) ? res : Array.isArray(res?.items) ? res.items : [];
      const partnerList = items.filter((item: any) => item._id !== this.loginUser && !oldPartnerIds.includes(item._id))              
      
      
      
      
      // exclude logged-in user
    // exclude existing partners

        const chunk = partnerList || [];
        if (chunk.length < this.selLimit) {
          this.selAllLoaded = true;
        }
        this.candidateCommunities = [...this.candidateCommunities, ...chunk];
        this.filteredCommunities = this.candidateCommunities;
        this.selSkip += chunk.length;
        this.selLoading = false;
      }, _ => {
        this.selLoading = false;
      });
  }

  openCommunitySelector(templateRef: any) {
    // reset pagination and load first page for selector
    this.selSkip = 0;
    this.selAllLoaded = false;
    this.selQuery = '';
    this.candidateCommunities = [];
    this.filteredCommunities = [];
    this.getCommunitiesForSelector(true);
    this.modalService.open(templateRef, { scrollable: true });
  }

  onCommunitySearchChange(event: any) {
    this.selQuery = (event?.target?.value || '').trim();
    // reset and fetch from server with search query
    this.getCommunitiesForSelector(true);
  }

  onSelectorScroll(evt: any) {
    const el = evt?.target;
    if (!el) return;
    // when scrolled within 80px of bottom, load next page
    const threshold = 80;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
      this.getCommunitiesForSelector();
    }
  }

  toggleCommunitySelection(c: any) {
    const id = c?._id;
    const idx = this.selectedCommunityIds.indexOf(id);
    if (idx >= 0) {
      this.selectedCommunityIds.splice(idx, 1);
      this.selectedCommunities = this.selectedCommunities.filter(x => x._id !== id);
    } else {
      this.selectedCommunityIds.push(id);
      this.selectedCommunities = [...this.selectedCommunities, c];
    }
    const names = this.selectedCommunities.map(x => x?.name).filter(Boolean);
    this.partnerName = names.length > 2 ? `${names[0]}, ${names[1]} +${names.length - 2}` : names.join(', ');
  }

  isCommunitySelected(id: string) {
    return this.selectedCommunityIds.includes(id);
  }

  submitAddPartner(modalRef?: any) {
    const ids = this.selectedCommunityIds || [];
    if (!ids.length) { return; }

    let remaining = ids.length;
    ids.forEach(id => {
      this.authService.addPartner(id).subscribe(
        _res => {
          remaining--;
          if (remaining === 0) {
            this.loadPartners();
            if (modalRef) modalRef.close('Save click');
          }
        },
        _err => {
          remaining--;
          if (remaining === 0) {
            this.loadPartners();
            if (modalRef) modalRef.close('Save click');
          }
        }
      );
    });
  }

  onRemovePartner(id: string) {
    if (!id) { return }
    this.authService.removePartner(id).subscribe(
      _res => {
        this.loadPartners();
      },
      _err => {
        console.error('Failed to remove partner', _err);
        this.loadPartners();
      }
    );
  }

  // ===== Tabs: update query params =====
  switchTab(type: 'partners' | 'request' | 'received') {
    const listType = type === 'partners' ? null : type;
    this.router.navigate([], {
      relativeTo: this.routeSvc,
      queryParams: { listType },
      queryParamsHandling: 'merge'
    });
  }

  isActiveTab(type: 'partners' | 'request' | 'received') {
    if (type === 'partners') return !this.listType;
    return this.listType === type;
  }

  // ===== Received request actions =====
  onApproveRequest(row: any, approve: boolean) {
    const requestedBy = row?.requestedBy?._id || row?.requestedBy || row?.communityId?._id;
    if (!requestedBy) return;
    const data = { isApproved: approve, requestedBy };
    this.authService.acceptDeclinePartnerRequest(data).subscribe(
      _ => this.loadPartners(),
      _ => this.loadPartners()
    );
  }

  // ===== Sent request actions =====
  onCancelSentRequest(row: any) {
    const communityId = row?.communityId?._id || row?.communityId;
    if (!communityId) return;
    this.authService.removePartner(communityId, this.listType).subscribe(
      _ => this.loadPartners(),
      _ => this.loadPartners()
    );
  }
}
